'use client'
import { useComponentTranslation } from '@core/i18n'
import { useLatencyWatcher } from '@core/network-connection'
import { Flex, Text } from '@core/ui-elements'

export const ConnectionLatencyStatus: React.FC = () => {
  const t = useComponentTranslation('ConnectionLatencyStatus')
  const latency = useLatencyWatcher()

  const classifyConnection = (value: number | null): string => {
    if (value === null) return ''
    if (value <= 300) return '| ' + t('Fast')
    if (value <= 600) return '| ' + t('Normal')
    if (value <= 1000) return '| ' + t('Slow')
    return '| ' + t('Unstable')
  }

  const formattedLatency =
    latency !== null ? `${latency.toFixed(2)}ms` : t('No connection')

  return (
    <Flex
      flex={2}
      flexDirection="column"
      fontSize={'0.75rem'}
      justifyContent={'center'}
      width={'100%'}
    >
      <Text color={'gray.400'} fontWeight="600" textAlign="center">
        {t('Connection speed')}:
      </Text>
      <Text color={'gray.400'} textAlign="center">
        {formattedLatency} {classifyConnection(latency)}
      </Text>
    </Flex>
  )
}
